import React from 'react';
import Autosuggest from 'react-autosuggest';

function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getSuggestionValue(suggestion) {
  return suggestion.stock_code;
}

function renderSuggestion(suggestion) {
  return (
    <span>
      <span className="fz-14 font-weight-bold text-white">
        {suggestion.stock_code}
      </span>
      <span className="fz-14 text-white">{` - ${suggestion.name_vn}`}</span>
    </span>
  );
}

class StockSuggest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      method: '',
      value: '',
      suggestions: [],
    };
  }

  getSuggestions = (value) => {
    const { dataSuggest } = this.props;

    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === '') {
      return [];
    }

    const regex = new RegExp('^' + escapedValue, 'i');

    return dataSuggest.filter((item) => regex.test(item.stock_code));
  };

  onChange = (event, { newValue, method }) => {
    // console.log(method)
    this.setState({
      method: (method === 'type' ? '' : method), 
      value: newValue,
    });
  };

  onKeyDown = (e) => {
    console.log(this.state.value)
    // return;
    if (e.keyCode === 13 && !this.state.method) {
      // Enter
      e.preventDefault();
      e.stopPropagation();
      const { suggestions } = this.state;
      // console.log(suggestions)
      // return;
      if (suggestions && !!suggestions.length) {
        this.props.addStock(suggestions[0].stock_code);
        this.setState({ value: '' });
      }
    }
  };

  onSuggestionSelected = (event, { suggestionValue, method }) => {
    // console.log(suggestionValue, method)
    // return
    this.props.addStock(suggestionValue);
    this.setState({ value: '' });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  render() {
    const { classname, placeholder } = this.props;
    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: placeholder, // 'Thêm mã CK'
      value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      className: classname, //form-add form-control fz-14
    };
    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        onSuggestionSelected={this.onSuggestionSelected}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    );
  }
}

export default StockSuggest;
